import { fetchData } from './fetch-data'

const InterfaceList = {
  api (bodyParams, headParams = '',httpType) {
    return fetchData(bodyParams,'/open/'+ headParams, httpType)
  }
}

export default InterfaceList
